<script setup>

</script>

<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.9997 3.39844C10.833 3.39844 3.33301 10.8818 3.33301 20.0984C3.33301 28.4318 9.43301 35.3484 17.3997 36.5984V24.9318H13.1663V20.0984H17.3997V16.4151C17.3997 12.2318 19.883 9.93177 23.6997 9.93177C25.5163 9.93177 27.4163 10.2484 27.4163 10.2484V14.3651H25.3163C23.2497 14.3651 22.5997 15.6484 22.5997 16.9651V20.0984H27.233L26.483 24.9318H22.5997V36.5984C26.5271 35.9782 30.1034 33.9743 32.6829 30.9485C35.2624 27.9228 36.6753 24.0745 36.6663 20.0984C36.6663 10.8818 29.1663 3.39844 19.9997 3.39844Z" fill="black"/>
  </svg>
</template>
